module.exports = __webpack_public_path__ + "static/lusine-0f895888b91454e72c6f5b4658c29788.png";